export enum UnitsOfMeasurementEnums {
    FeetAndInches = 1,
    Meters = 2,
    Pounds = 3,
    Kilograms = 4,
}
